import ACTIONS from "../constants/actions";

const { GET_ALL_BRANCH_ORG } = ACTIONS;

const initialState = {
  allBranches: [],
};

const metaDataOrgReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BRANCH_ORG:
      return {
        ...state,
        allBranches: action.payload,
      };
    default:
      return state;
  }
};

export default metaDataOrgReducer;
